import styled from 'styled-components';
import { fullScreenSpinner } from '../../css/zindex';

export const Wrapper = styled.div`
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        opacity: 0.4,
        zIndex: ${fullScreenSpinner}
`;
